module.exports = __webpack_public_path__ + "img/koshaspt_SNB.45c4df0a.svg";